/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { Dwin, DwinInterface } from "../../contracts/Dwin";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "getTotalNetBets",
    outputs: [
      {
        internalType: "uint256[2]",
        name: "",
        type: "uint256[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
      {
        internalType: "enum Dwin.Vote",
        name: "bet",
        type: "uint8",
      },
    ],
    name: "makeBet",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "numProposals",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "openMarket",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "proposals",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenYesId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenNoId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "yayVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "nayVotes",
        type: "uint256",
      },
      {
        internalType: "enum Dwin.Vote",
        name: "outcome",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "treasury",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposalId",
        type: "uint256",
      },
      {
        internalType: "enum Dwin.Vote",
        name: "vote",
        type: "uint8",
      },
    ],
    name: "voteOnProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "payoutAfterFee",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type DwinConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DwinConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Dwin__factory extends ContractFactory {
  constructor(...args: DwinConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Dwin> {
    return super.deploy(overrides || {}) as Promise<Dwin>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Dwin {
    return super.attach(address) as Dwin;
  }
  override connect(signer: Signer): Dwin__factory {
    return super.connect(signer) as Dwin__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DwinInterface {
    return new utils.Interface(_abi) as DwinInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Dwin {
    return new Contract(address, _abi, signerOrProvider) as Dwin;
  }
}
